import type { JSX } from 'react';

import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconStar } from '@change-corgi/design-system-legacy/icons';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

type Props = {
	text: string;
	selected: boolean;
	isSunriseEnabled: boolean;
};

export function HighlightText({ text, selected, isSunriseEnabled = true }: Props): JSX.Element {
	return (
		<Box
			sx={{
				textAlign: 'center',
				borderTopLeftRadius: 'standard',
				borderTopRightRadius: 'standard',
				backgroundColor: selected ? 'sunrise.semantic.fill.accent.primary.weaker' : 'transparent',
				marginBottom: -1,
				...(isSunriseEnabled && {
					color: selected ? 'sunrise.semantic.typography.accent.primary' : 'sunrise.semantic.typography.strong',
					borderTopLeftRadius: 11, // the parent box has a border radius of 12, so we need to subtract 1px to avoid the border overlap
					borderTopRightRadius: 11, // the parent box has a border radius of 12, so we need to subtract 1px to avoid the border overlap
					alignItems: 'center',
					justifyContent: 'flex-start',
					display: 'flex',
					px: 24,
					pt: 16,
				}),
			}}
		>
			<Flex
				sx={{
					alignItems: 'center',
					justifyContent: 'center',
					py: 4,
					fontSize: 12,
					px: 8,
					borderRadius: 999,
					backgroundColor: selected ? 'sunrise.semantic.fill.accent.primary.strong' : 'sunrise.semantic.fill.weaker',
					gap: 4,
				}}
			>
				<Icon
					icon={iconStar}
					size="l"
					data-qa="ppmu-modal-highlight-icon"
					sx={{
						color: selected ? 'sunrise.semantic.icon.inverse.strong' : 'sunrise.semantic.icon.strong',
					}}
				/>
				<Text
					fontWeight="semibold"
					size="caption"
					data-qa="ppmu-modal-highlight-text"
					sx={{
						fontSize: 12,
						color: selected ? 'sunrise.semantic.typography.inverse.strong' : 'sunrise.semantic.typography.strong',
					}}
				>
					{text}
				</Text>
			</Flex>
		</Box>
	);
}
